/** Setores internos — espelha enum Prisma `UserSetor` e departamentos dos forms C1/C4. */
export const userSetorOptions = [
  { value: 'ADMINISTRATIVO', label: 'Administrativo' },
  { value: 'MARKETING', label: 'Marketing' },
  { value: 'SUPORTE', label: 'Suporte' },
  { value: 'COMERCIAL', label: 'Comercial' },
  { value: 'CRIACAO', label: 'Criação' },
  { value: 'PROJETOS', label: 'Projetos' },
  { value: 'INOVACAO', label: 'Inovação' },
  { value: 'MARKETPLACES', label: 'Marketplaces' },
  { value: 'ROCKETSEARCH', label: 'Rocket Search' },
  { value: 'PARTNERS', label: 'Partners' },
  { value: 'CRO', label: 'CRO' },
] as const

export type UserSetorValue = (typeof userSetorOptions)[number]['value']

const setorLabels = Object.fromEntries(userSetorOptions.map((o) => [o.value, o.label])) as Record<
  UserSetorValue,
  string
>

export function getUserSetorLabel(setor: string | null | undefined): string {
  if (!setor) return '—'
  return setorLabels[setor as UserSetorValue] ?? setor
}
